import { render, staticRenderFns } from "./DraggableFieldSelector.vue?vue&type=template&id=1a9fdf0a&"
import script from "./DraggableFieldSelector.vue?vue&type=script&lang=js&"
export * from "./DraggableFieldSelector.vue?vue&type=script&lang=js&"
import style0 from "./DraggableFieldSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports